import React from "react"
import {FieldGlistGroupProps} from "../../../../render/glist/glist-group"

export default function FieldRating_GlistGroupStandard(props:FieldGlistGroupProps) {
    const value = props.data.value

    // @ts-ignore
    const stars:boolean[] = new Array(props.field.scale).fill(true).fill(false, value);

    return (
        <div className="group-cards">
            <div className="ui5-chip s30 transparent p-h-0">
                {_.map(stars, (value:boolean, key:number)=>{
                    const classes:string = Classes("icon", {
                        'filled i5-star'       : value,
                        'empty i5-star-empty'  : !value,
                    })
                    return <div key={key} className={classes}/>
                })}
            </div>
            {!!props.data.isCollapsed && <div className="counter">{props.data.counter}</div>}

            {!props.data.isCollapsed &&
                <div className="group-corners">
                    <div className="top-corner"/>
                </div>}
        </div>
    )
}
